import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { CONTENT_TYPE, JSON_CONTENT_TYPE } from "../common";
export var jsonOptions = {
  headers: _defineProperty({}, CONTENT_TYPE, "".concat(JSON_CONTENT_TYPE, "; charset=UTF-8"))
};